import base from './base2.repository';
export default {
    getPendingPeople: (clientId, page = 1) => base.get(`people/client/${clientId}/pending-activation`, {page}),
    activateMobileUser: payload => base.post(`people/activate-user`, payload),
    getPeoplePendingActivation: (filters, page) => base.get(`people/pending-activation`, {...filters, page}),
    deleteStore: (id) => base.delete('people/reject-user/' +id),
    rejectUser: (id) => base.delete(`people/reject-user/${id}`), 
}